module.exports = __webpack_public_path__ + "img/dashboard_bg.b0afbd07.png";